<header>
    <app-header headerName="Forgot Password"></app-header>
  </header>

<section *ngIf="notOpen">
    <div class="outer-conatiner">
       <div class="inner-container">
        <app-page-title pageTitle='Village of Volo Overnight Parking'></app-page-title>
          <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
           <div>
            <i class="fa fa-unlock-alt" aria-hidden="true"></i> 
            <h1 color="vov-ui-primary">Forgot Password</h1>
           </div>
          <div class="container-wrapper">
             <mat-form-field appearance="fill">
                <mat-label>Registration email</mat-label>
                <input  formControlName="email" placeholder="" type="text"  matInput required pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"/>
                <mat-error *ngIf="forgotPasswordForm.get('email').hasError('required') || forgotPasswordForm.get('email').hasError('pattern')">
                  Please enter the email
                </mat-error> 
             </mat-form-field>
             <button mat-button class="button-primary" type="submit" [disabled]='forgotPasswordForm.invalid'  color="vov-ui-primary" >Change password</button>
             <a style="padding: 22px;  display: flex;justify-content: center;color: #6A0721;font-weight: bold;text-decoration: none; cursor: pointer;" (click)="goBackToLogin()" color="vov-ui-primary" >Back to Login</a>
          </div>
        </form>
       </div>
    </div>
  </section> 

